<template>
    <div class="border-t bg-white overflow-auto py-4 rounded shadow">
      <div class="font-semibold text-l mx-4 mb-4 text-gray-500">Foot fall</div>
        <div class="px-2">
            <canvas id="foot_fall" class=""></canvas>
        </div>
    </div>
</template>

<script>
import Chart from 'chart.js';
import GraphQl from "../../services/graphql.service";
import moment from 'moment'

export default {
        name: "Footfall",
        props: {
            filters: Object
        },
        data() {
            return {
                planetChartData: {
                    data: {
                        datasets: [
                            {
                                label: "Footfall",
                                type: 'line',
                                fill: false,
                                backgroundColor: '#FEEBC8',
                                showLines: false,
                                borderColor: '#ED8936',
                                lineTension: .4,
                                borderWidth: 2,
                                data: []
                            }
                        ]
                    },
                    options: {
                        legend: {
                            display: false,
                            labels: {
                                fontColor: 'teal'
                            }
                        },
                        scales: {
                            yAxes: [{
                                scaleLabel: {
                                    display: true,
                                    labelString: "Customers"
                                }
                            }],
                            xAxes: [{
                                type: "time",
                                distribution: 'linear'
                            }],
                        }
                    }
                },
            }
        },
        mounted() {
            this.loadStats();
        },
        watch: {
            filters: {
                handler: function () {
                    this.loadStats();
                },
                deep: true
            }
        },
        methods: {
            loadStats() {
              let v = [];
              this.filters.venues.forEach(function (venue) {
                v.push(venue.id);
              });
              let params = (this.filters.venues.length > 0 ? 'venues:["' + v.join('","') + '"],' : '') +
                'startDate: "' + this.filters.dateRange.startDate + '", ' +
                'endDate: "' + this.filters.dateRange.endDate + '"';

                this.planetChartData.data.datasets[0].data = [];
                GraphQl.sendRequest('{organization(id:"' + this.$store.getters.orgId + '") {footfall('+params+'){footfall, time}}}', this.filters)
                    .then(response => {
                        response.organization.footfall.forEach((stat) => {
                            this.planetChartData.data.datasets[0].data.push({
                                t: moment(stat.time, 'YYYY-MM-DD HH:mm').valueOf(),
                                y: stat.footfall
                            });
                        });
                        new Chart(document.getElementById("foot_fall"), {
                            type: 'line',
                            data: this.planetChartData.data,
                            options: this.planetChartData.options,
                        });
                    })
            }
        }
    }
</script>

<style scoped>

</style>